export default "__VITE_ASSET__7BVicIRm__"